import BreadCrumb from "./src/BreadCrumb.vue";
export * from "./types/types";
export default BreadCrumb;
